var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"spotPricingTabs"}},[_c('ejs-tab',{ref:"spotPricingTabs",attrs:{"id":"element"}},[_c('e-tabitems',[_c('e-tabitem',{attrs:{"header":_vm.headerText0,"content":_vm.spotPricing}}),_c('e-tabitem',{attrs:{"header":_vm.headerText1,"content":_vm.spotPricingLogs}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }